import PolicyClause from "./PolicyClause";

function PolicySection({ section }) {
    return (
        <div className="terms-section">
            {(section.section || section.title) && (
                <h3>
                    {section.section && `${section.section}.`} {section.title}
                </h3>
            )}

            {section.clauses?.map((clause) => {
                const clauseNumber = Object.keys(clause)[0];

                return (
                    <PolicyClause
                        key={clauseNumber}
                        clause={clause}
                    />
                );
            })}
        </div>
    );
}

export default PolicySection;
